export default {
  placeholder: 'Entrez le nom du restaurant',
  labels: {
    cant_find_place: 'Vous ne trouvez pas le lieu dans la liste ?',
    reset_categories: 'Réinitialiser les catégories de lieu',
  },
};
